// extracted by mini-css-extract-plugin
export default {"modalView":"UserCard_modalView__EGG9c"};